import React from 'react';
import { Col, Row, Button } from 'reactstrap';
import { Dialog } from 'primereact/dialog';



export const DialogPreviewResultsMicrosite = (props) => {

    const {
        modalPreviewPDF, setModalPreviewPDF, pdfPreviewUrl, setPdfPreviewUrl, loadingPdfPreview
    } = props;


    return (
<Dialog
    header="Previsualización de PDF"
    visible={modalPreviewPDF}
    style={{ width: '70vw' }}
    modal
    onHide={() => {
        setModalPreviewPDF(false);

        if (pdfPreviewUrl) {
            URL.revokeObjectURL(pdfPreviewUrl);
            setPdfPreviewUrl(null);
        }
    }}

      headerStyle={{
                backgroundColor: '#0d3b59',
                color: 'white',
                fontWeight: 'bold',
            }}
>
    {
        loadingPdfPreview ? (
            < >
                <Row className='mt-2'> <br />
                    <Col sm="12" md="12" lg="12" className='text-center'>  <br /> <br /> <br /> <br />
                        <img src={require("../../../assets/images/loginHelenLabs/HelenLabs.png")} className='animate__animated animate__pulse animate__infinite ' style={{ width: '130px' }} />
                    </Col>
                </Row>
                <Row className='mt-2'>
                    <Col sm="3" md="3" lg="3" className='text-center'></Col>
                    <Col sm="2" md="2" lg="2" className='text-left p-r-0'>
                        <p className='f-18 text-primary animate__animated animate__pulse animate__infinite'> <b>Cargando</b></p>
                    </Col>
                    <Col sm="1" md="1" lg="1" className='text-center'>
                        <br />
                        <p className='animate__animated animate__fadeInDown animate__infinite text-info'><i className="fa fa-circle f-14"></i></p>
                    </Col>
                    <Col sm="1" md="1" lg="1" className='text-center'>
                        <br />
                        <p className='animate__animated animate__fadeInDown animate__slow animate__infinite text-primary'><i className="fa fa-circle f-14"></i></p>
                    </Col>
                    <Col sm="1" md="1" lg="1" className='text-center'>
                        <br />
                        <p className='animate__animated animate__fadeInDown animate__slower animate__infinite text-info'><i className="fa fa-circle f-14"></i></p>
                    </Col>
                    <Col sm="2" md="2" lg="2" className='text-center'></Col>
                </Row>
            </>
        ) : (
            pdfPreviewUrl && (
                <embed
                    src={pdfPreviewUrl}
                    type="application/pdf"
                    width="100%"
                    height="600px"
                />
            )
        )
    }
</Dialog>
   
    )
}